var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3V2C2 0.895 2.895 0 4 0H16C17.105 0 18 0.895 18 2V3C18 3.552 17.552 4 17 4C16.448 4 16 3.552 16 3C16 2.448 15.552 2 15 2H5C4.448 2 4 2.448 4 3C4 3.552 3.552 4 3 4C2.448 4 2 3.552 2 3ZM12 12C12 13.105 11.105 14 10 14C8.895 14 8 13.105 8 12C8 10.895 8.895 10 10 10C11.105 10 12 10.895 12 12ZM18 9.657L16.343 8C17.972 8 18 8.384 18 9.657ZM16.343 16L18 14.343C18 15.97 17.62 16 16.343 16ZM6.485 16L2.485 12L6.485 8H13.515L17.515 12L13.515 16H6.485ZM2 14.343L3.657 16C2.03 16 2 15.62 2 14.343ZM3.657 8L2 9.657C2 8.028 2.384 8 3.657 8ZM18 6H2C0.895 6 0 6.895 0 8V16C0 17.105 0.895 18 2 18H18C19.105 18 20 17.105 20 16V8C20 6.895 19.105 6 18 6Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.720053e11e28f32e1d8420c191cfb8c6.svg";
export { ForwardRef as ReactComponent };